import { render, staticRenderFns } from "./EnrollWallet.vue?vue&type=template&id=189a6fa6&"
import script from "./EnrollWallet.vue?vue&type=script&lang=js&"
export * from "./EnrollWallet.vue?vue&type=script&lang=js&"
import style0 from "./EnrollWallet.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports